// lib
import { styled } from '@nykaa/ui-components';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: calc(33.33% - 12px);
  margin-right: ${({ theme }) => theme.spacing.spacing120};
  ${({ theme }) => theme.typography.bodyMedium}
`;

export const EcomPolicyText = styled.h3`
  text-align: left;
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0 0 auto 0;
`;

export const EcomPolicyImage = styled.img`
  position: relative;
  left: 0;
  margin-top: ${({ theme }) => theme.spacing.spacing80};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  width: 40px;
  height: 40px;
`;

export const EcomPolicyCardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
`;
